import {OFFER_DETAIL_PAGE} from "../action/actionConstants";

export default function InputBox(state = "", action) {
  switch (action.type) {
    case OFFER_DETAIL_PAGE:
      return action.payload;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/offerDetailPage.js